import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import { FETCH_API_KEYS, CREATE_API_KEY, UPDATE_API_KEY, DELETE_API_KEY } from "../../urls";

class ApiKeysService {
  fetchApiKeys = async (page = 1, perPage = 10, term = "", sortBy = "id", order = "DESC") => {
    try {
      const response = await apiBase.get(
        FETCH_API_KEYS(page, perPage, term, sortBy, order)
      );
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  createApiKey = async (name, description, applicationId) => {
    try {
      const response = await apiBase.post(CREATE_API_KEY, {
        name,
        description,
        applicationId,
      });
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  updateApiKey = async (id, name, description, applicationId, active) => {
    try {
      const response = await apiBase.put(UPDATE_API_KEY(id), {
        name,
        description,
        applicationId,
        active,
      });
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  deleteApiKey = async (id) => {
    try {
      const response = await apiBase.delete(DELETE_API_KEY(id));
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };
}

export default new ApiKeysService();

